import React, { useEffect, useState } from "react";
import { TIME_FORMAT1 } from "../../constants/stringConstants";
import "../../css/chats.css";
import { addDotOnBigLine, DateFormatter } from "../../functions/commons";
import { ChatSessionsType } from "../../interfaces/chats";
import CompanyAvatar from "../Avatars/CompanyAvatar";

interface chatTileProps {
  data: ChatSessionsType;
  onChatClick: Function;
  activeChat: boolean;
}

function ChatTile(props: chatTileProps) {
  const { data, onChatClick, activeChat } = props;
  const { chats, company, jobApplication } = data;

  return (
    <div
      className={`chat_tile ${activeChat && "chat_tile_selected"}`}
      onClick={() => onChatClick()}
    >
      <div className="chat_image_icon_container">
        {!company.companyLogo ? (
          <CompanyAvatar />
        ) : (
          <img
            // className="chat_image_icon"
            src={company.companyLogo}
            height="45"
            width="45"
            style={{ borderRadius: "100%" }}
          />
        )}
      </div>
      <div className="leftNavChatTileSec">
        <div className="chat_tile_name_message">
          <text>{company.companyName}</text>
          {/* <text>{addDotOnBigLine(chats[0].content, 37)} </text> */}
          <text>{addDotOnBigLine(chats[0].content, 37)} </text>
        </div>
        <div>
          <text>{DateFormatter(chats[0].createdAt, TIME_FORMAT1)}</text>
        </div>
      </div>
    </div>
  );
}

export default ChatTile;
